import { Typography } from "@mui/material";
import FullScreenDialog from "components/FullScreenDialog";
import MDBox from "components/MDBox";
import { IResultadoCorrida } from "interfaces/resultadoCorrida";

// imagesn
import pdf_transparent from "../../../../assets/images/icons/pdf_transparent.png";
import DropzoneComponent from "./Dropzone";

interface Props {
  open: boolean;
  onClose: () => void;
  isUpdate: () => void;
  selectedEvento: IResultadoCorrida;
}
export default function ModalFullFilePDF({
  open,
  onClose,
  selectedEvento,
  isUpdate,
}: Props) {
  return (
    <FullScreenDialog
      open={open}
      title="Adicionar arquivos PDF"
      handleClose={onClose}
    >
      <MDBox display="flex" justifyContent="center" my={2}>
        <MDBox width={{ xs: "95%", md: "75%" }}>
          <MDBox display="flex" gap={2} my={2}>
            <img src={pdf_transparent} height={80} width="auto" alt="wiclax" />
            <MDBox>
              <Typography variant="subtitle1">
                Enviar os arquivos de resultados do evento em formato PDF
              </Typography>
              <Typography variant="h4">{selectedEvento?.titulo}</Typography>
            </MDBox>
          </MDBox>

          {selectedEvento && (
            <DropzoneComponent
              onClose={onClose}
              selectedEvento={selectedEvento}
              isUpadate={isUpdate}
            />
          )}
        </MDBox>
      </MDBox>
    </FullScreenDialog>
  );
}
